import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from 'react-intl';
import { Button, buttonTypes } from 'moods-react/Button';

import Dialog from '../DialogComponent';
import messages from '../../../../data/products';
import '../DialogButtons.scss';

const DeleteDialogComponent = ({ description, actions }, context) => {
  const { formatMessage } = context.intl;
  const closeCurrentOverlay = () => {
    actions.closeOverlay();
  };

  const closeAndDeleteAction = () => {
    closeCurrentOverlay();
    actions.deleteAction();
  };

  return (
    <Dialog
      title={formatMessage(messages.deleteDialogTitle)}
      description={description}
      closeOverlay={actions.closeOverlay}
    >
      <div className="dialog-component__buttons">
        <Button
          onClick={closeCurrentOverlay}
          type={buttonTypes.STANDALONE_WHITE}
          data-delete-dialog-cancel
          className="dialog-button"
        >
          {formatMessage(messages.deleteDialogButtonCancel)}
        </Button>
        <Button onClick={closeAndDeleteAction} data-delete-dialog-delete className="dialog-button">
          {formatMessage(messages.deleteDialogButtonDelete)}
        </Button>
      </div>
    </Dialog>
  );
};

DeleteDialogComponent.displayName = 'DeleteDialog';

DeleteDialogComponent.propTypes = {
  description: PropTypes.node.isRequired,
  actions: PropTypes.shape({
    closeOverlay: PropTypes.func.isRequired,
    deleteAction: PropTypes.func,
  }).isRequired,
};

DeleteDialogComponent.contextTypes = {
  intl: intlShape.isRequired,
};

export default DeleteDialogComponent;
